<template>
    <div>
        <div class="top_box">
            <h2>等待授权启动救援案件</h2>
            <div class="time_box">
                <div class="block st_box">
                    起始时间
                    <el-date-picker
                    @change="sttime()"
                    v-model="st_time"
                    align="right"
                    type="date"
                    placeholder="起始时间"
                    :picker-options="pickerOptions1">
                    </el-date-picker>
                </div>
                <div class="block en_box">
                    结束时间
                    <el-date-picker
                    @change="entime()"
                    v-model="en_time"
                    align="right"
                    type="date"
                    placeholder="结束时间"
                    :picker-options="pickerOptions1">
                    </el-date-picker>
                </div>
                <div class="block en_box">
                    案件编号
                    <el-input v-model="caseNo" placeholder="案件编号" style="width: 213px;"></el-input>
                </div>
                <div class="block">
                  <el-button type="primary" @click="filt()">查询</el-button>
                </div>
            </div>
        </div>
        <formVue :token="token" :st_time="st_time" :en_time="en_time" :flag="flag" :sereen="sereen" :typeId="typeId" :caseNo="caseNo"/>
    </div>
</template>

<script>
import formVue from "./form.vue";
export default {
  data() {
    return {
      sereen: false,
      token:
        this.$route.params.token ||
        JSON.parse(window.localStorage.getItem("data")).data,
      st_time: "",
      en_time: "",
      caseNo: "",
      flag: this.$route.params.flag,
      typeId: this.$route.query.typeId,
      pickerOptions1: {
        disabledDate(time) {
          return time.getTime() > Date.now();
        }
      }
    };
  },
  components: {
    formVue
  },
  methods: {
    filt() {
      if (this.st_time && !this.en_time) {
        this.sereen = false;
      } else if (this.en_time && !this.st_time) {
        this.sereen = false;
      } else if (!this.st_time && !this.en_time) {
        this.sereen = false;
      } else {
        this.sereen = true;
      }
    },
    sttime() {
      this.st_time = this.st_time * 1;
    },
    entime() {
      this.en_time = this.en_time * 1;
      console.log(this.en_time);
    }
  },
  mounted() {
    window.localStorage.setItem(
      "case",
      JSON.stringify({
        case: "RegAwait"
      })
    );
  }
};
</script>

<style scoped>
@import url("../../css/table.css");
</style>


// WEBPACK FOOTER //
// src/components/regulator/await.vue